if (!customElements.get('assortment-interact')) {
   class Assortment extends HTMLElement {
      constructor() {
         super();
         this.active = false;
         this.variantId = null;
         this.handle = null;
         this.productId = null;
         this.tags = [];
         this.current_kio = false;
         this._isProcessing = false;
         this._processingTags = new Set();
         this._handleClick = this.handleClick.bind(this);
         this._handleAssortmentAdded = this.handleAssortmentAdded.bind(this);
         this._handleAssortmentRemoved = this.handleAssortmentRemoved.bind(this);
         this._toggleTagConnection = this.toggleTagConnection.bind(this);
         this._handleTagAdded = this.handleTagAdded.bind(this);
         this._handleTagRemoved = this.handleTagRemoved.bind(this);
      }
      connectedCallback() {
         this._syncFromDOM();
         try {
            this.tags = JSON.parse(this.querySelector('[data-custom-tags]')?.innerText || '[]');
            const kioText = this.querySelector('[data-current-kio]')?.innerText.trim();
            if (kioText) this.current_kio = JSON.parse(kioText);
         } catch (e) {
            console.error('[Assortment] Failed to parse initial data:', e);
         }
         this.querySelector('button')?.addEventListener('click', this._handleClick);
         document.addEventListener('on:product-assortment:add', this._handleAssortmentAdded);
         document.addEventListener('on:product-assortment:remove', this._handleAssortmentRemoved);
         document.addEventListener('on:tag:added', this._handleTagAdded);
         document.addEventListener('on:tag:removed', this._handleTagRemoved);
         this.querySelectorAll('li').forEach(item => item.addEventListener('click', this._toggleTagConnection));
      }
      disconnectedCallback() {
         this.querySelector('button')?.removeEventListener('click', this._handleClick);
         document.removeEventListener('on:product-assortment:add', this._handleAssortmentAdded);
         document.removeEventListener('on:product-assortment:remove', this._handleAssortmentRemoved);
         document.removeEventListener('on:tag:added', this._handleTagAdded);
         document.removeEventListener('on:tag:removed', this._handleTagRemoved);
         this.querySelectorAll('li').forEach(item => item.removeEventListener('click', this._toggleTagConnection));
      }
      _syncFromDOM() {
         const customer = window.customer ?? {};
         this.user = customer.currentUserNumber ?? null;
         this.customerId = customer.id ?? null;
         this.userName = customer.userName ?? null;
         this.active = this.dataset.active === 'true';
         this.variantId = this.dataset.variantId ?? null;
         this.handle = this.dataset.handle ?? null;
         this.productId = this.dataset.productId ?? null;
      }
      async handleClick() {
         if (this._isProcessing) return;
         this._isProcessing = true;
         const btn = this.querySelector('button');
         if (btn) btn.disabled = true;
         if(this.querySelector(`.assortment-custom-list`)) this.querySelector(`.assortment-custom-list`).classList.add(`loading`);
         try {
            this.active ? await this.handleRemoveFromKio() : await this.handleAddToKio();
         } catch (err) {
            console.error('[Assortment] handleClick failed:', err);
         } finally {
            this._isProcessing = false;
            if (btn) btn.disabled = false;
            if(this.querySelector(`.assortment-custom-list`)) this.querySelector(`.assortment-custom-list`).classList.remove(`loading`);
         }
      }
      async toggleTagConnection({ target }) {
         const li = target.closest('li');
         if (!li) return;
         const { filter, included } = li.dataset;
         if (this._processingTags.has(filter)) return;
         this._processingTags.add(filter);
         li.style.pointerEvents = 'none';
         const closest = target.closest('assortment-interact');
         if(closest?.querySelector(`.assortment-custom-list`)) closest.querySelector(`.assortment-custom-list`).classList.add('loading');
         if(closest?.querySelector(`button`)) closest.querySelector(`button`).disabled = true;
         try {
            included === 'true' ? await this._handleDisconnectTag(filter) : await this._handleConnectTag(filter);
         } catch (err) {
            console.error('[Assortment] toggleTagConnection failed:', err);
         } finally {
            this._processingTags.delete(filter);
            li.style.pointerEvents = '';
            if(closest?.querySelector(`.assortment-custom-list`)) closest.querySelector(`.assortment-custom-list`).classList.remove('loading');
            if(closest?.querySelector(`button`)) closest.querySelector(`button`).disabled = false;
         }
      }
      async _fetchAssortment(tag, action) {
         const { customerId, userName, userNumber } = this.getRequestParams();
         const res = await fetch(`${location.origin}/apps/stroetmann/api/v1/customers/set_assortment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
               customerId,
               userName,
               userNumber,
               filterName: tag,
               newFilterName: tag,
               filterValue: { handle: this.handle, action },
            }),
         });
         if (!res.ok) throw new Error(`[Assortment] set_assortment failed: ${res.status}`);
         return res;
      }
      async _handleConnectProduct(tag) {
         return this._fetchAssortment(tag, 'add');
      }
      async _handleDisconnectProductFromTag(tag) {
         return this._fetchAssortment(tag, 'remove');
      }
      async _handleConnectTag(tag) {
         if (!this.active){
            await this.handleAddToKio(tag);
            await this._handleConnectProduct(tag);
         } else {
            await this._handleConnectProduct(tag);
            this._dispatchAdd(tag);
         }
         // await this._handleConnectProduct(tag);
         // !this.active ? await this.handleAddToKio(tag) : this._dispatchAdd(tag);
      }
      async _handleDisconnectTag(tag) {
         await this._handleDisconnectProductFromTag(tag);
         this._dispatchRemove(tag);
      }
      // ─────────────────────────────────────────────────────────────────────────
      // ASSORTMENT REMOVED
      // ─────────────────────────────────────────────────────────────────────────
      async handleAssortmentRemoved({ detail }) {
         const { handle, tag, variantId } = detail;
         //console.log(`handleAssortmentRemoved >>`,detail)
         if (handle !== this.handle) return;
         if (tag) {
            this.tags = this.tags.map(currentTag => {
               if (currentTag.name !== tag) return currentTag;
               const updatedHandles = currentTag.handles.filter(h => h !== handle);
               // Canonical count from the updated handles array
               const count = updatedHandles.length;
               // Patch every li[data-filter] on the page (all cards)
               document.querySelectorAll(`li[data-filter="${currentTag.name}"]`).forEach(el => {
                  el.dataset.count = count;
                  el.dataset.included = String(el.closest('assortment-interact')?.dataset?.handle === handle ? false : currentTag.handles.includes(el.closest('assortment-interact')?.dataset?.handle ?? ''));
                  const counter = el.querySelector('[data-count]');
                  if (counter) counter.innerHTML = count;
               });
               return {
                  ...currentTag,
                  handles: updatedHandles
               };
            });
         } else {
            const tags = Array.isArray(this.tags) ? this.tags : [];
            const removeFromTags = tags.filter(t => t.handles?.includes(this.handle)).map(t => t.name);
            this.tags = tags.map(t => ({
               ...t,
               handles: (t.handles || []).filter(h => h !== this.handle),
            }));
            for (const tagName of removeFromTags) {
               try {
                  await this._handleDisconnectProductFromTag(tagName);
                  const updatedTag = this.tags.find(t => t.name === tagName);
                  const count = updatedTag?.handles?.length ?? 0;
                  document.querySelectorAll(`li[data-filter="${tagName}"]`).forEach(el => {
                     el.dataset.count = count;
                     el.dataset.included = 'false';
                     const countEl = el.querySelector('[data-count]');
                     if (countEl) countEl.innerHTML = count;
                  });
               } catch (err) {
                  console.error(`[Assortment] Failed to disconnect tag "${tagName}":`, err);
               }
            }
         }
         this._dispatchUpdate();
         
         if (this.variantId !== variantId) return;

         if(!tag){
            // remove item from kio
            this.active = false;
            this.querySelector('[data-current-kio]').innerText = '';
         }

         this.dataset.active = String(this.active);
         this.current_kio = false;
      }
      // ─────────────────────────────────────────────────────────────────────────
      // ASSORTMENT ADDED
      // ─────────────────────────────────────────────────────────────────────────
      async handleAssortmentAdded({ detail }) {
         const { handle, tag, variantId } = detail;
         //console.log(`handleAssortmentAdded >>`,detail, this.tags)
         if (tag) {
            this.tags = this.tags.map(currentTag => {
               if (currentTag.name !== tag) return currentTag;
               const alreadyTracked = currentTag.handles.includes(handle);
               const updatedHandles = alreadyTracked ? currentTag.handles : [...currentTag.handles, handle].filter(h => h?.trim());
               // Canonical count — never read from DOM arithmetic
               const count = updatedHandles.length;
               // Patch every li[data-filter] across all cards on the page
               document.querySelectorAll(`li[data-filter="${currentTag.name}"]`).forEach(el => {
                  el.dataset.count = count;
                  const ownerHandle = el.closest('assortment-interact')?.dataset?.handle;
                  el.dataset.included = String(updatedHandles.includes(ownerHandle ?? ''));
                  const counter = el.querySelector('[data-count]');
                  if (counter) counter.innerHTML = count;
               });
               return {
                  ...currentTag,
                  handles: updatedHandles
               };
            });
         }
         if (handle === this.handle && this.variantId == variantId) {
            this.active = true;
            this.dataset.active = 'true';
         }
      }
      // ─────────────────────────────────────────────────────────────────────────
      // KIO HELPERS
      // ─────────────────────────────────────────────────────────────────────────
      getRequestParams() {
         return {
            customerId: window.customer?.id ?? this.customerId,
            userName: window.customer?.userName ?? this.userName,
            userNumber: window.customer?.currentUserNumber ?? this.user,
         };
      }
      _isB2B() {
         return window.customer?.currentUserNumber?.startsWith('b2b_');
      }
      async handleAddToKio(tag = null) {
         if (this._isB2B()) return;
         const kioText = this.querySelector('[data-current-kio]')?.innerText.trim();
         if (kioText) this.current_kio = JSON.parse(kioText);
         const formData = this._buildKioFormData();

         if (this.current_kio) {
            formData.set('variantId', this.current_kio.variantId);
            const res = await fetch('/apps/stroetmann/api/v1/users/delete_kio', {
               method: 'POST',
               body: formData
            });

            //as400 offline case handling
            if(res.ok){
               const resJson = await res.json();
               if(resJson?.errors?.length){
                  const errorsContent = resJson.errors.join('');
                  if (errorsContent.includes('server_offline')) {
                     const servrOfflineModal = document.getElementById(`serverOfflineModal`);
                     if(servrOfflineModal) servrOfflineModal.setAttribute(`open`,``);
                     return;
                  }
               }
            }
         }

         const getVariantId = this.getAttribute('data-variant-id') || this.variantId;
         formData.set('variantId', `gid://shopify/ProductVariant/${getVariantId}`);
         
         const res = await fetch('/apps/stroetmann/api/v1/users/create_kio', {
            method: 'POST',
            body: formData
         });
         if (!res.ok) return;

         //as400 offline case handling
         if(res.ok){
            const resJson = await res.json();
            if(resJson?.errors?.length){
               const errorsContent = resJson.errors.join('');
               if (errorsContent.includes('server_offline')) {
                  const servrOfflineModal = document.getElementById(`serverOfflineModal`);
                  if(servrOfflineModal) servrOfflineModal.setAttribute(`open`,``);
                  return;
               }
            }
         }

         this.querySelector('[data-current-kio]').innerText = JSON.stringify({
            variantId: `gid://shopify/ProductVariant/${this.variantId}`,
            handle: this.handle,
            sales: null,
         });
         this._dispatchAdd(tag);
         return res;
      }
      async handleRemoveFromKio(tag = null) {
         if (this._isB2B()) return;
         const kioText = this.querySelector('[data-current-kio]')?.innerText.trim();
         if (kioText) this.current_kio = JSON.parse(kioText);
         if (!this.current_kio) return;
         const formData = this._buildKioFormData();
         const getVariantId = this.getAttribute('data-variant-id') || this.variantId;
         formData.set('variantId', `gid://shopify/ProductVariant/${getVariantId}`);
         const res = await fetch('/apps/stroetmann/api/v1/users/delete_kio', {
            method: 'POST',
            body: formData
         });
         if (!res.ok) return;

         //as400 offline case handling
         if(res.ok){
            const resJson = await res.json();
            if(resJson?.errors?.length){
               const errorsContent = resJson.errors.join('');
               if (errorsContent.includes('server_offline')) {
                  const servrOfflineModal = document.getElementById(`serverOfflineModal`);
                  if(servrOfflineModal) servrOfflineModal.setAttribute(`open`,``);
                  return;
               }
            }
         }

         // Invalidate this product's cache entry so stale data is never shown
         // after it leaves the KIOS (reusable helper defined in custom.js).
         if (typeof clearMyAssortmentCache === 'function') {
            await clearMyAssortmentCache(this.getAttribute('data-product-id'));
         }

         this._dispatchRemove(tag);
         return res;
      }
      _buildKioFormData() {
         const fd = new FormData();
         fd.set('customerId', this.customerId ?? '');
         fd.set('userNumber', this.user ?? '');
         fd.set('userName', this.userName ?? '');
         return fd;
      }
      // ─────────────────────────────────────────────────────────────────────────
      // TAG ADDED / REMOVED
      // ─────────────────────────────────────────────────────────────────────────
      handleTagAdded({ detail }) {
         const { filter } = detail;
         this.tags.push({ handles: [], name: filter });
         const markup = `
        <li class="flex flex-row" data-filter="${filter}" data-included="false" data-count="0">
          <span data-not-included>
            <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"
                 fill="none" fill-rule="evenodd" stroke-linejoin="round"
                 aria-hidden="true" focusable="false" role="presentation" class="icon">
              <path d="M5 19 19 5M5 5l14 14"/>
            </svg>
          </span>
          <span data-is-included>
            <svg style="width:24px;height:24px" viewBox="0 0 24 24"
                 aria-hidden="true" focusable="false" role="presentation" class="icon">
              <path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8-1.41-1.42Z"/>
            </svg>
          </span>
          <span>${filter.split(':')[0]}</span>
          <span data-count>0</span>
        </li>`;
         this.querySelector('.assortment-custom-list ul').insertAdjacentHTML('beforeend', markup);
         this.querySelector(`li[data-filter="${filter}"]`).addEventListener('click', this._toggleTagConnection);
      }

      handleTagRemoved({ detail }) {
         const { tag } = detail;
         this.tags = this.tags.filter(t => t.name !== tag);
         this.querySelector(`li[data-filter="${tag}"]`)?.remove();
      }
      // ─────────────────────────────────────────────────────────────────────────
      // VARIANT CHANGE
      // ─────────────────────────────────────────────────────────────────────────
      async handleVariantChange({ detail }) {
         this.variantId = detail.variant.id;
         this.current_kio = false;
         const kioText = this.querySelector('[data-current-kio]')?.innerText.trim();
         if (kioText) this.current_kio = JSON.parse(kioText);
         if (!this.current_kio) return;
         if (this._isB2B()) return;
         const formData = this._buildKioFormData();
         formData.set('variantId', this.current_kio.variantId);

         const res = await fetch('/apps/stroetmann/api/v1/users/delete_kio', {
            method: 'POST',
            body: formData
         });

         //as400 offline case handling
         if(res.ok){
            const resJson = await res.json();
            if(resJson?.errors?.length){
               const errorsContent = resJson.errors.join('');
               if (errorsContent.includes('server_offline')) {
                  const servrOfflineModal = document.getElementById(`serverOfflineModal`);
                  if(servrOfflineModal) servrOfflineModal.setAttribute(`open`,``);
                  return;
               }
            }
         }

         formData.set('variantId', `gid://shopify/ProductVariant/${this.variantId}`);

         await fetch('/apps/stroetmann/api/v1/users/create_kio', {
            method: 'POST',
            body: formData
         });
         this.querySelector('[data-current-kio]').innerText = JSON.stringify({
            handle: this.handle,
            variantId: `gid://shopify/ProductVariant/${this.variantId}`,
            sales: this.current_kio.sales,
         });
      }
      // ─────────────────────────────────────────────────────────────────────────
      // DISPATCH HELPERS
      // ─────────────────────────────────────────────────────────────────────────
      _dispatchAdd(tag = null) {
         this._dispatch('on:product-assortment:add', tag);
      }
      _dispatchRemove(tag = null) {
         this._dispatch('on:product-assortment:remove', tag);
      }
      _dispatchUpdate() {
         document.dispatchEvent(new CustomEvent('on:product-assortment:update', {
            detail: {
               handle: this.handle,
               tags: this.tags
            },
         }));
      }
      _dispatch(event, tag) {
         document.dispatchEvent(new CustomEvent(event, {
            detail: {
               handle: this.handle,
               variantId: this.variantId,
               productId: this.productId,
               tag,
            },
         }));
      }
   }
   customElements.define('assortment-interact', Assortment);
}